import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tomografia-computarizada',
  templateUrl: './tomografia-computarizada.component.html',
  styleUrls: ['./tomografia-computarizada.component.css']
})
export class TomografiaComputarizadaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
